import { Button } from '../../primitives';
import { BaseModal } from './BaseModal';

interface DeleteModalProps {
  open: boolean;
  title?: string;
  description?: React.ReactNode;
  onDelete: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export const DeleteModal = ({
  open,
  title = 'Delete',
  description = 'Are you sure you want to delete this item?',
  onDelete,
  onCancel,
  loading = false,
}: DeleteModalProps) => {
  return (
    <BaseModal
      open={open}
      title={title}
      description={description}
      onClose={onCancel}
      actions={
        <>
          <Button variant="outlined" onClick={onCancel} disabled={loading}>
            Huỷ
          </Button>
          <Button
            variant="outlined"
            sx={{ color: 'red', borderColor: 'red' }}
            onClick={onDelete}
            loading={loading}
          >
            Xoá
          </Button>
        </>
      }
    />
  );
};